"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Element#closest polyfill
var element_closest_1 = require("element-closest");
if (typeof window !== 'undefined')
    element_closest_1.default(window);
var _1 = require(".");
function trackEvent(category, action, name) {
    var gtag = window.gtag, piwik = window.piwik;
    if (gtag) {
        gtag('event', 'click', Object.assign({
            event_category: category,
            event_action: action,
        }, name && {
            event_label: name,
        }));
    }
    if (piwik) {
        piwik.trackEvent(category, action, name);
    }
}
exports.onClientEntry = function () {
    { // 사이트 접속 추적
        // pathname이 변경된 것은 사이트 접속으로 보지 않음.
        trackEvent('autotrack-entry', 'entry', location.pathname);
    }
    window.addEventListener('click', function (e) {
        var target = e.target;
        if (!target || !target.closest)
            return;
        var element = target.closest('a[id], button[id], input[id]');
        if (!element)
            return;
        trackEvent('autotrack-click', 'click', element.id);
    }, true);
    { // 페이지의 어디까지 방문했는지 확인하기 위해서 location.hash 변동을 추적함.
        var timerId_1;
        _1.onhashchange(function (hash) {
            window.clearTimeout(timerId_1);
            if (!hash)
                return;
            // hash가 변경되고 0.5초 이상 그대로 유지될 경우 사용자가 유의미하게 해당 화면을 방문했다고 간주함.
            timerId_1 = window.setTimeout(function () {
                trackEvent('autotrack-visit', 'hash', hash);
            }, 500);
        });
    }
};
exports.onRouteUpdate = function (_a) {
    var location = _a.location, prevLocation = _a.prevLocation;
    // 어차피 pageview는 gatsby-plugin-google-analytics와 gatsby-plugin-matomo 에서 전용 api를 따로 호출함.
    // 그래서 따로 트래킹할 필요는 없으나 편의상 이벤트로도 넣음.
    if (!prevLocation || location.pathname !== prevLocation.pathname) {
        trackEvent('autotrack-pageview', 'pageview', location.pathname);
    }
};
